import React from 'react';

export const Warning = ({ children }) => (
  <div
    className="bg-yellow-50 border-t-4 border-yellow-500 rounded-b text-yellow-800 px-4 py-3 shadow-md mb-5"
    role="alert"
  >
    <div className="flex pt-5">
      <div className="py-1 mr-4">⚠️</div>
      <div className="[&_*]:mt-0">{children}</div>
    </div>
  </div>
);
